<template>
  <div class="cuerpo">
    <Movimientos></Movimientos>
  </div>
</template>

<script>
import Movimientos from "@/components/Movimientos.vue";

export default {
  name: "MovimientosView",
  components: {
    Movimientos,
  },
};
</script>

<style></style>
